import React from 'react';
import { TemplateDefault } from '../../templates/TemplateDefault';
// import s from './PageNotFound.module.scss';

export const PageNotFound: React.FC = () => {
  return <TemplateDefault>404</TemplateDefault>;
};
